module.exports = __webpack_public_path__ + "25c9bd68ac17b3b6db3a15aacacd1716.png";